import app from './app/reducer';
import brand from './brand/reducer';
import applePay from './applePay/reducer';
import googlePay from './googlePay/reducer';
import consent from './consent/reducer';

export default {
    app,
    brand,
    applePay,
    googlePay,
    consent,
};
